import { Theme } from "./theme";

export const lightTheme: Theme = {
    primaryBackground: 'white',
    primaryBorder: '#DADADA',
    primaryForeground: 'black',
    primaryText: 'black',
    primaryColor: '#2196F3',
    secondaryText: '#757575',
    reviewCardBackground: '#EEEEEE',
    secondaryBackground: '#F9F9F9',
    secondaryBorder: '#DADADA',
    secondaryIcon: '#5B5B5B',
    successButtonForeground: 'white',
    successButtonBackground: '#56BA58',
    successButtonBorder: '#519252',
    failButtonForeground: 'white',
    failButtonBackground: '#DD544C',
    failButtonBorder: '#A15347',
    neutralButtonBackground: '#E0E0E0',
    neutralButtonForeground: 'black',
    neutralButtonBorder: '#9E9E9E',
    cardShadow: '#E3E3E3',
    floatingButtonBackground: '#7C7C7C',
    floatingButtonShadow: 'RGBA(124,124,124,0.5)',
    inputBackground: '#F0F0F0',
    inputBorder: '#DADADA',
    inputText: 'black',
    accentColor: '#2196F3',
    dangerColor: '#f44336',
    dangerColorHover: '#d32f2f',
    successColor: '#4caf50',
    successColorHover: '#45a049',
    overlayBackground: 'rgba(0, 0, 0, 0.2)',
    hoverBackground: '#E8E8E8',
    buttonText: 'white',
    error: '#d32f2f',
    accentColorDark: '#1976d2',
}